import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CustomerModel } from '@libs/account/models';
import { MatCard, MatCardContent } from '@angular/material/card';
import { DateTime } from 'luxon';
import { OrderAddressesComponent } from '../../../order/order-addresses/order-addresses.component';
import { OrderCheckoutReferenceTextComponent } from '../../../order/order-checkout-reference-text/order-checkout-reference-text.component';
import { OrderDeliveryComponent } from '../../../order/order-delivery/order-delivery.component';
import { OrderPaymentComponent } from '../../../order/order-payment/order-payment.component';

@Component({
  selector: 'ui-checkout-details',
  imports: [
    OrderAddressesComponent,
    OrderDeliveryComponent,
    OrderPaymentComponent,
    OrderCheckoutReferenceTextComponent,
    MatCardContent,
    MatCard,
  ],
  templateUrl: './checkout-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './checkout-details.component.scss',
})
export class CheckoutDetailsComponent {
  public customer: InputSignal<CustomerModel> = input.required();
  public deliveryDate: InputSignal<DateTime | undefined> = input();
  public orderCustomReferenceText: InputSignal<string | undefined> = input();
}
